class SubscriptionUtility extends HTMLElement {


    constructor() {
        super()
    }

    async updateSubscription(line, quantity, sellingPlanId) {
        await fetch(
            `/cart/change.js?sections=${document
                .querySelector('cart-drawer')
                .getAttribute('data-section-id')}`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                body: JSON.stringify({
                    line,
                    quantity,
                    selling_plan: sellingPlanId,
                }),
            }
        ).then(async (res) => {
            const data = await res.json()
            const { dataHandler } = this.querySelector('cart-form').updateCart()
            dataHandler(data)
        })
    }
}

if (!customElements.get('subscription-utility')) {
    customElements.define("subscription-utility", SubscriptionUtility)
}